import React from 'react';

import { BodySerializer } from '../serializer';

import { BodyStore } from './body.store';

export const bodyStore = new BodyStore(new BodySerializer());

export const BodyAdapter = React.createContext(bodyStore);
